'use strict';

import $ from "jquery";
// var moment = require('moment');
import getTime from 'date-fns/get_time';

var TWEEN = require('@tweenjs/tween.js');
var requestAnimationFrame = require('raf');
var THREE = require('three');
var Modernizr = require('./modernizr-custom.js');
var Tone = require('tone');
import anime from 'animejs';

import { ofClamp, ofRandom, ofMap } from './p';
import { detectIE, isMobile } from './utils';

// Replace here
var coverCanvas, coverCtx;
var introCanvas, introCtx;
var partCanvas, partCtx;

var startT, now, t;
var mousePos, mousePosP;
var cover = new Object();

//_mode engine
var _mode = 0;
var _modeP = 0;

var v3;

var intro = true;
var checkCanvas;

$(function(){
  isTouch = Modernizr.touchevents;

	//$(window).scroll(checkScroll);
	$(window).resize(checkResize);
	// $(window).mousemove(function(e) {
	// 	mouseMove(e.pageX,e.pageY);
	// });

  checkCanvas = setInterval(function() {
    const check = document.getElementById("coverCanvas");

    if (check) {
      initCoverCanvas();
      initIntroCanvas();
      initPartCanvas();

      initCover();

      // initThree();
      // initMotion();
      initLiquid();
      initPart();
      // initTouch();
      initLogoChar();


      render();
      checkResize();

      minifyCover(false);
      changeMode(1);

      clearInterval(checkCanvas);
    }
  }, 500);
});

//three
var camera;
var scene;
var planeGroup;
var renderer;
var plane;
var bgBalls;
var plane0;
var plane1;
var plane2;
var plane3;
var plane4;
var tex0;
var tex1;
var tex2;
var tex3;
var tex4;
//wave 3D scene setting
var currentWScene = -1;

//shader
//shader

//part
var liquid = new Array();
var unitW = 30;
var liquidW = Math.ceil(1200/unitW);//1200
var liquidH = Math.ceil(670/unitW);//670
var visc = 0.5;
var partSpeedMax = 20;
var historyMax = 8;
var partTotal =0;//total particle spawned
//
var partSys = new Array();
var partMax = 250;
var partLife = 30;
var speedFactor = 1;
var wave = new Object();
wave.scaleFactor = 1;
wave.alpha = 1;

wave.swipeToAlpha = 0;
wave.waveAlpha = 0;//all wave
wave.partAlpha = 0;
wave.wave2Alpha = 0;//wave in logo positioin
wave.wave3Alpha = 0;//wave in i(s)
wave.vdLogoAlpha = 0;
wave.vdChar = new Array();
for(var i=0;i<16;i++){
	var obj = new Object();
	obj.alpha = 0;
  //fade out
  obj.scale = ofRandom(0.5,0.8);
	obj.dur = ofRandom(1500,2000);

  obj.delay = ofRandom(0,1000);
	if(i==1 || i==6 || i==13){
		obj.delay = 1000;
	}
  //fade in
  obj.dur = 1000;
  obj.delay0 = 100+(i%5)*120+i*50;
  obj.angStart = 0;
  obj.angEnd = 0;
  //
  switch (i) {
    case 0:
      obj.maskType = 0;
      obj.offsetX = -25;
      obj.offsetY = -25;
    break;
    case 1:
      obj.maskType = 0;
      obj.offsetX =  12;
      obj.offsetY = -25;
    break;
    case 2:
      obj.maskType = 1;
      obj.offsetX = 0;
      obj.offsetY = 0;
    case 3:
      obj.maskType = 0;
      obj.offsetX = 25;
      obj.offsetY = 0;
    break;
    case 4:
      obj.maskType = 1;
      obj.offsetX = 0;
      obj.offsetY = 0;
    break;
    case 5:
      obj.maskType = 0;
      obj.offsetX = 0;
      obj.offsetY = 25;
    break;
    case 6:
      obj.maskType = 0;
      obj.offsetX = -12;
      obj.offsetY = 25;
    break;
    case 7:
      obj.maskType = 0;
      obj.offsetX = 0;
      obj.offsetY = 25;
    break;
    /////////////
    case 8:
      obj.maskType = 1;
      obj.offsetX = 0;
      obj.offsetY = 0;
    break;
    case 9:
      obj.maskType = 1;
      obj.offsetX = 0;
      obj.offsetY = 0;
    break;
    case 10:
      obj.maskType = 1;
      obj.offsetX = 0;
      obj.offsetY = 0;
    break;
    case 11:
      obj.maskType = 0;
      obj.offsetX = -25;
      obj.offsetY = 0;
    break;
    case 12:
      obj.maskType = 0;
      obj.offsetX = 25;
      obj.offsetY = 0;
    break;
    case 13:
      obj.maskType = 0;
      obj.offsetX = 12;
      obj.offsetY = -25;
    break;
    case 14:
      obj.maskType = 1;
      obj.offsetX = 0;
      obj.offsetY = 0;
    break;
    case 15:
      obj.maskType = 0;
      obj.offsetX = 25;
      obj.offsetY = 0;
    break;

    default:

  }


	wave.vdChar.push(obj);
}
wave.slantT = 0;
wave.t = 0;

//
var isStill=false;
var isTouch = false;
var hasMotion = false;
var forceX, forceY;
var tttMotion;

//part

function initThree() {
	camera = new THREE.PerspectiveCamera( 70, window.innerWidth / window.innerHeight, 1, 100000 );
	camera.position.z = 200;
	camera.position.y = 400;
	scene = new THREE.Scene();

	planeGroup = new THREE.Object3D();
	scene.add(planeGroup);

	//renderer = new THREE.WebGLRenderer({ antialias: true } );
	renderer = new THREE.WebGLRenderer( );

	renderer.alpha = false;
	renderer.setClearColor(0x000000, 1);
	renderer.antialias = false;
	renderer.depth = false;
	renderer.setFaceCulling(false);
	renderer.sortObjects = false;
	renderer.setPixelRatio( window.devicePixelRatio );
	renderer.setSize( window.innerWidth, window.innerHeight );
	renderer.domElement.id = 'threeCanvas';
	document.getElementById('threeCanvasWrapper').appendChild( renderer.domElement );
	//
	//


	window.addEventListener( 'resize', onWindowResize, false );
}

function onWindowResize() {
	camera.aspect = window.innerWidth / window.innerHeight;
	camera.updateProjectionMatrix();
	renderer.setSize( window.innerWidth, window.innerHeight );
}



function initPart() {
	for (var i = 0; i < partMax; i++) {
		var obj = new Object();
		obj.id = i;
		obj.pos = new THREE.Vector2(ofRandom(0, 800), ofRandom(0, 800));
		obj.life = partLife+ofRandom(0,50);
		obj.posHis = new Array();
		obj.posHisMax = historyMax;
		obj.isActive = false;
		obj.e1= ofRandom(0.7,0.9);
		obj.e2 = 1-obj.e1;
		obj.speedMax = partSpeedMax;
		obj.rot = 0;
		var color = new THREE.Color("hsl("+Math.floor(ofRandom(0,255))+", 100%, "+Math.floor(ofRandom(0,100))+"%)");
		obj.strokeStyle = "#"+color.getHexString();
		obj.color;
		obj.cR;
		obj.cG;
		obj.cB;
		partSys.push(obj);
	}
}

function initTouch() {
	document.addEventListener('touchmove', function(e) {
	    // e.preventDefault();
	    mouseMove(e.targetTouches[0].pageX, e.targetTouches[0].pageY);
	}, false);
}

function initLiquid() {
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = new Object();
			obj.force = new THREE.Vector2(0, 0);
			obj.force2 = new THREE.Vector2(0, 0);//for calculation
			obj.force3 = new THREE.Vector2(0, 0);//last legit force

			obj.alpha = 0;
			obj.rot = 0;

			obj.delayForce = new Array();
			for (var k = 0; k < 100; k++) {
				obj.delayForce.push(new THREE.Vector2(0, 0) );
			}
						//obj.fX = ofRandom(-10,10);
						//obj.fY = ofRandom(-10,10);

						//obj.fX2 = 0;
						//obj.fY2 = 0;


			//			obj._x = i;
			//			obj._y = j;
			//			obj.x_1y_1 = liqGetIndex(i-1,j-1);
			//			obj.x0y_1 = liqGetIndex(i,j-1);
			//			obj.x1y_1 = liqGetIndex(i+1,j-1);
			//
			//			obj.x_1y0 = liqGetIndex(i-1,j);
			//			obj.xy0 = liqGetIndex(i,j);
			//			obj.x1y0 = liqGetIndex(i+1,j);
			//
			//			obj.x_1y1 = liqGetIndex(i-1,j+1);
			//			obj.x0y1 = liqGetIndex(i,j+1);
			//			obj.x1y1 = liqGetIndex(i+1,j+1);

						liquid.push( obj  );
		}
	}
}



var logoCharList = new Array();

function initLogoChar() {
	var str = "VICTORIADOCKSIDE";
	var charList = str.split("");
	for(var i=0;i<16;i++){
		var char = document.getElementById("vdLogo_"+charList[i]+"_ForCanvas");
		logoCharList.push(char);
	}
}


function initCoverCanvas() {
	coverCanvas = document.getElementById("coverCanvas");
	coverCtx = coverCanvas.getContext("2d");
	//
	// startT = moment();
	startT = getTime(new Date());
	//
	mousePos = new THREE.Vector2(0,0);
	mousePosP = new THREE.Vector2(0,0);
}

function initIntroCanvas() {
	introCanvas = document.getElementById("introCanvas");
	introCtx = coverCanvas.getContext("2d");
}

function initPartCanvas() {
	partCanvas = document.getElementById("partCanvas");
	partCtx = partCanvas.getContext("2d");
}


function initCover() {
	cover.scale = 10;
	cover.scale2 = 1;
	cover.isOn = false;
	cover.rotate = 0;
	cover.rotateT = 0.5;

	cover.update = function(){
		this.rotateT += 0.005;
		this.rotate = this.rotate*0.9 + this.rotateT*0.1;
	};
	cover.rotateTo = function(ang){
		this.rotateT = ang/180*Math.PI;
	};
	cover.rotateBy = function(ang){
		this.rotateT += ang/180*Math.PI;
	}
}

function initMotion() {

	if(window.DeviceMotionEvent!=undefined && isTouch){
		hasMotion = true;
		// console.log("has motion");

		window.ondevicemotion = function(event) {
			forceX = event.accelerationIncludingGravity.x;
			forceY = event.accelerationIncludingGravity.y;
			//console.log("Accelerometer data - x: " + event.accelerationIncludingGravity.x + " y: " + event.accelerationIncludingGravity.y + " z: " +event.accelerationIncludingGravity.z);

			//$('#status').html(ax);
		}
		tttMotion = setTimeout(function () {
			if(forceX == undefined){//not a touch device
				hasMotion = false;
				clearTimeout(tttMotion);
			}
		}, 1000);
	}else{
		hasMotion = false;
		//console.log("no motion");
	}

	if (window.DeviceMotionEvent==undefined) {

	} else {

	}
}
//3d scene
function setWScene(n) {// setup THREE for scene



	clearWScene();
	currentWScene = n;

	// Reann edit THREE here

  if(n!=-1){
		switch (n) {
			case 0:
				tex0 = new THREE.Texture(partCanvas);
				tex0.needsUpdate = true;
				//tex0.wrapS = THREE.MirroredRepeatWrapping;
				tex0.wrapS = THREE.RepeatWrapping;

				tex0.wrapT = THREE.RepeatWrapping;
				tex0.offset.set(0.3,0.3);
				tex0.repeat.set(4, 4);

				var geo0 = new THREE.PlaneGeometry(8000,8000, 2, 2);
				var mat0 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex0, transparent:true , blending: THREE.AdditiveBlending} );
				plane0 = new THREE.Mesh(geo0, mat0);
				plane0.rotation.x = -Math.PI*0.5;
				plane0.rotation.z  = Math.PI*0.1
				plane0.position.z = -4000;
				planeGroup.add(plane0);
				plane0.position.z = 0;


				tex1 = new THREE.TextureLoader().load("static/threeScene/seaTex.jpg");
				var geo1 = new THREE.PlaneGeometry(8000,8000, 2, 2);
				var mat1 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex1 ,blending: THREE.NormalBlending} );
				plane1 = new THREE.Mesh(geo1, mat1);
				plane1.rotation.x = -Math.PI*0.5;
				plane1.position.z = -4000;
				planeGroup.add(plane1);
				plane1.position.z = 0;
				plane1.position.y = -20;

        tex4 = new THREE.TextureLoader().load("static/threeScene/cloud.png");
        //tex4.needsUpdate = true;
        tex4.wrapS = THREE.RepeatWrapping;
        tex4.wrapT = THREE.RepeatWrapping;
        tex4.offset.set(0.3,0.3);
        tex4.repeat.set(4, 4);
        var geo4 = new THREE.PlaneGeometry(8000,8000, 4, 4);
        var mat4 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex4,transparent:true ,blending: THREE.NormalBlending} );
        plane4 = new THREE.Mesh(geo4, mat4);
        plane4.rotation.x = -Math.PI*0.5;
        plane4.position.z = -4000;
        planeGroup.add(plane4);
        plane4.position.z = 0;
        plane4.position.y = 900;

				tex2 = new THREE.TextureLoader().load("static/threeScene/build0.png");
				var geo2 = new THREE.PlaneGeometry(512,1024, 2, 2);
				var mat2 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex2,transparent: true, premultipliedAlpha:true} );
				plane2 = new THREE.Mesh(geo2, mat2);
				plane2.rotation.x = 0;
				planeGroup.add(plane2);
				plane2.position.z = -300;
				plane2.position.x = 300;
				plane2.position.y = 512*0.9;
				plane2.scale.set(0.9,0.9,1);

				tex3 = new THREE.TextureLoader().load("static/threeScene/background0.jpg");
				var geo3 = new THREE.PlaneGeometry(1024,512, 2, 2);
				var mat3 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex3} );
				plane3 = new THREE.Mesh(geo3, mat3);
				plane3.rotation.x = 0;
				planeGroup.add(plane3);
				plane3.position.z = -3000;
				plane3.position.x = 100;
				plane3.position.y = 256*8;
				plane3.scale.set(8,8,8);
			break;

			case 1:
				tex0 = new THREE.Texture(partCanvas);
				tex0.needsUpdate = true;
				tex0.wrapS = THREE.MirroredRepeatWrapping;
				tex0.wrapT = THREE.MirroredRepeatWrapping;
				tex0.offset.set(0.3,0.3);
				tex0.repeat.set(4, 4);

				var geo0 = new THREE.PlaneGeometry(8000,8000, 2, 2);
				var mat0 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex0, transparent:true , blending: THREE.AdditiveBlending} );
				plane0 = new THREE.Mesh(geo0, mat0);
				plane0.rotation.x = -Math.PI*0.5;
				plane0.position.z = -4000;
				planeGroup.add(plane0);
				plane0.position.z = 0;

				tex1 = new THREE.TextureLoader().load("static/threeScene/background1.jpg");
				var geo1 = new THREE.PlaneGeometry(1024,256, 2, 2);
				var mat1 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex1 ,blending: THREE.NormalBlending} );
				plane1 = new THREE.Mesh(geo1, mat1);
				plane1.rotation.x = 0;
				plane1.position.z = -20000;
				planeGroup.add(plane1);
				plane1.position.y = 128*50+2200;
				plane1.scale.set(50,50,1);

				tex2 = new THREE.TextureLoader().load("static/threeScene/dock.png");
				var geo2 = new THREE.PlaneGeometry(1024,512, 2, 2);
				var mat2 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex2, transparent:true ,blending: THREE.NormalBlending} );
				plane2 = new THREE.Mesh(geo2, mat2);
				plane2.rotation.x = 0;
				plane2.position.x = 300;
				plane2.position.z = -500;
				planeGroup.add(plane2);
        plane2.position.y = 256*1.2-50;
        plane2.scale.set(1.2,1.2,1);


				// tex3 = new THREE.TextureLoader().load("assets/images/threeScene/scene.jpg");
				// var geo3 = new THREE.PlaneGeometry(830,408, 2, 2);
				// var mat3 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex3} );
				// plane3 = new THREE.Mesh(geo3, mat3);
				// plane3.rotation.x = 0;
				// planeGroup.add(plane3);
				// plane3.position.z = -4000;
				// plane3.position.x = 0;
				// plane3.position.y = 204*6;
				// plane3.scale.set(6,6,1);


			break;
		}
	}

}
function renderWScene(n) {
	switch (n) {
		case 0:
      var offset;
      var s;
			tex0.needsUpdate = true;
			offset = tex0.offset.x-0.0002;
			tex0.offset.set(offset,offset);

      tex4.needsUpdate = true;
      offset = tex4.offset.x+0.0008;
      tex4.offset.set(offset,-offset);

			//
			var windowRatio = window.innerWidth / window.innerHeight;
      plane2.position.x = ofMap(windowRatio,0.9,2,120,550,false);
      //
      s = ofMap(windowRatio,1,2,8,10,false);
      plane3.scale.set(s,s,1);
      plane3.position.y = 256*s;
      //
      s = ofMap(windowRatio,1,2,1,1.5,false);
      plane1.scale.set(s,s,1);
		break;
		case 1:
			tex0.needsUpdate = true;
      var offset;
      var s;
      var windowRatio = window.innerWidth / window.innerHeight;
      plane2.position.x = ofMap(windowRatio,1,2,300,550,false);
		break;
	}
}
function clearWScene() {

	if(planeGroup){
		while( planeGroup.children.length>0 ){
			planeGroup.remove(planeGroup.children[0]);
		}
	}
}


// init
function checkMode() {
	switch (_mode) {
		case 0://default
		break;
		case 1://
		break;
		case 10://
		break;
		case 40://
		break;

	}
}

//
//
//
//
//
//
//
//
//
//
//
//



function changeMode(i) {
	_modeP = _mode;
	_mode = i;
	if(_mode != _modeP){
		switch (_mode) {
			case 0:
			break;
			case 1:// wait for swipe
				//wave.tween = new TWEEN.Tween(wave).to({t:10},10000).start();

				// wave.tween = new TWEEN.Tween(wave).to({vdLogoAlpha:1},1000).start();
				for(var i=0;i<16;i++){
				// 	wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({alpha:1},1000).delay(0).start();
        wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({alpha:1},wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).start();
        wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({scale:0.75},wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();
          wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({offsetX:0},wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();
          wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({offsetY:0},wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();

          wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({angEnd:Math.PI*2},wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();

				}
        wave.tween = new TWEEN.Tween(wave).to({waveAlpha:1},800).delay(1100).start();
				//wave.tween2 = new TWEEN.Tween(wave).to({logoAlpha:1},2000).delay(1000).start();
				var ttt = setTimeout(function(){changeMode(10);} ,5000);

			break;
			case 2:// fade in waves, fade out swipe, fade in logo, and delay to enter
				// wave.tween = new TWEEN.Tween(wave).to({swipeToAlpha:0},1000).start();
				// wave.tween = new TWEEN.Tween(wave).to({waveAlpha:1},500).start();
				// wave.tween = new TWEEN.Tween(wave).to({wave3Alpha:1},1000).delay(2000).start();
        // wave.tween = new TWEEN.Tween(wave).to({partAlpha:0},1000).start();

				//wave.tween = new TWEEN.Tween(wave).to({vdLogoAlpha:0},1000).delay(100).start();


				//wave.vdCharDelay = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
				//wave.vdCharAlpha = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];



				// var ttt = setTimeout(function(){changeMode(10);} ,10000000);//4000
			break;
			case 10:// fade out waves, according to how close to the i, 3i left
				wave.tween = new TWEEN.Tween(wave).to({waveAlpha:0},500).start();// handle in render()
				// wave.tween = new TWEEN.Tween(wave).to({vdLogoAlpha:0},1000).delay(2000).start();
				wave.tween = new TWEEN.Tween(wave).to({slantT:1},2000).delay(100).start();

				for(var i=0;i<16;i++){
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({alpha:0},wave.vdChar[i].dur).delay(wave.vdChar[i].delay).start();
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({scale:ofRandom(0.5,1)},wave.vdChar[i].dur).delay(wave.vdChar[i].delay).start();
				}

				var ttt = setTimeout(function(){changeMode(40);} ,4000);

				break;
			// case 20:// fade 3 i
			// 		//wave.tween = new TWEEN.Tween(wave).to({waveAlpha:0},500).start();// handle in render()
			// 		wave.tween = new TWEEN.Tween(wave).to({wave3Alpha:0},1000).start();
			//
			// 		var ttt = setTimeout(function(){changeMode(40);} ,1000);
			// 		break;

			case 40://
        wave.tween = new TWEEN.Tween(wave).to({scaleFactor:1.2},3000).easing(TWEEN.Easing.Quintic.Out).start();
        //wave.tween = new TWEEN.Tween(wave).to({partAlpha:1},1000).start();
				cover.rotate = 1.7;
				cover.rotateT = 1.7;
        $('#partCanvas').fadeOut(2000);
        closeCover(true);
				//enter site here
        const header = document.querySelector('.header');
        const menuContainer = document.querySelector('.menu__container');
        const siteContainer = document.getElementById('site-content__container');
        const allButtons = document.querySelectorAll('button');
        const social = document.querySelector('.social__container');

        for (let i = 0; i < allButtons.length; i += 1) {
          allButtons[i].disabled = false;
        }

        setTimeout(() => {
          menuContainer.style.zIndex = '98';
          social.style.zIndex = '98';
          intro = false;
        }, 1000);

        document.querySelector('.page-background__container .cover-0 video').play();

        if (window.innerWidth >= 768) {
          anime({
            targets: [header, menuContainer, siteContainer, menuContainer.children[0], social],
            opacity: 1,
            easing: 'easeOutSine',
            duration: 300,
            delay: 1000,
          });
        } else {
          anime({
            targets: [header, menuContainer, siteContainer],
            opacity: 1,
            easing: 'easeOutSine',
            duration: 300,
            delay: 1000,
          });
        }

        if (!isMobile('all')) {
          startMusic();
        }

        // console.log('case 40');
			break;
			case 50://
				// $('#threeCanvasWrapper').show();
        partCanvas.width = 1024;
        partCanvas.height = 1024;
				wave.scaleFactor = 1;
				wave.waveAlpha = 1;
				wave.wave2Alpha = 1;

			break;


		}
	}
}



function drawCover() {

	coverCtx.fillStyle = "#000";
	//coverCtx.fillRect(0,0,coverCanvas.width, coverCanvas.height);

	coverCtx.beginPath();
	coverCtx.moveTo(0,0);
	coverCtx.lineTo(coverCanvas.width,0);
	coverCtx.lineTo(coverCanvas.width,coverCanvas.height);
	coverCtx.lineTo(0,coverCanvas.height);
	coverCtx.lineTo(0,0);
	coverCtx.closePath();

	var m = cover.scale;
  var hoverFeedback = cover.scale2;
  var slantW = 340*m*hoverFeedback;
  var slantH = 84*m*hoverFeedback;

	coverCtx.save();
	coverCtx.translate(coverCanvas.width/2,coverCanvas.height/2);
	//coverCtx.rotate(t*0.0005);
	coverCtx.rotate(cover.rotate);
	coverCtx.translate(-slantW/2,-slantH/2);
	coverCtx.moveTo(0,0);
	coverCtx.lineTo(0,slantH);
	coverCtx.lineTo(slantW,slantH);
	coverCtx.lineTo(slantW,0);
	coverCtx.lineTo(0,0);
	coverCtx.closePath();

	coverCtx.restore();

	coverCtx.fill();
}

function updateLiquid() {
	var v1 = visc;
	var v2 = (1 - v1) / 2;

	var comp1 = 0.20710678118654754;//component 1, 1/(0.707*4+2)
	var comp2 = 0.14644660940672627;//component 2, 0.707/(0.707*4+2)


	//reset
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = liquid[i +j * liquidW];
				obj.force2.set(0, 0);
		}
	}

	// delay force
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = liquid[i +j * liquidW];
			obj.force2.x += obj.delayForce[0].x;
			obj.force2.y += obj.delayForce[0].y;

			var pos = new THREE.Vector2(0,0);
			obj.delayForce.unshift(pos);
			var posLast = obj.delayForce.pop();
			obj.force2.x += posLast.x;
			obj.force2.y += posLast.y;
		}
	}

	//

	//

	//average force
	for (var j = 1; j < liquidH-1; j++) {
		for (var i = 1; i <liquidW - 1; i++) {
			var obj0 = liquid[i +j * liquidW];
			var objW = liquid[i - 1 +j * liquidW];
			var objE = liquid[i + 1 +j * liquidW];

			var objNW = liquid[i - 1 +(j-1) * liquidW];
			var objNE = liquid[i + 1 +(j-1) * liquidW];

			var objSW = liquid[i - 1 +(j+1) * liquidW];
			var objSE = liquid[i + 1 +(j+1) * liquidW];


			v1 = visc+ofRandom(-0.05,0.05);
			//v1 = visc;
			v2 = (1 - v1)* comp1;
			v3 = (1 - v1)* comp2;


			obj0.force2.x += (obj0.force.x *v1 + (objW.force.x+objE.force.x) *v2 +  (objNW.force.x+objNE.force.x+objSW.force.x+objSE.force.x)* v3 ) * 1;
		}
	}

	for (var i = 1; i < liquidW-1; i++) {
		for (var j = 1; j <liquidH - 1; j++) {
			var obj0 = liquid[i +j * liquidW];
			var objN = liquid[i + (j - 1) * liquidW];
			var objS = liquid[i + (j + 1) * liquidW];

			var objNW = liquid[i - 1 +(j-1) * liquidW];
			var objSW = liquid[i - 1 +(j+1) * liquidW];

			var objNE = liquid[i + 1 +(j-1) * liquidW];
			var objSE = liquid[i + 1 +(j+1) * liquidW];


			v1 = visc+ofRandom(-0.05,0.05);
			//v1 = visc;
			v2 = (1 - v1)* comp1;
			v3 = (1 - v1)* comp2;

			//obj0.force2.y += (obj0.force.y *v1 + objN.force.y *v2 + objS.force.y * v2) *1;
			obj0.force2.y += (obj0.force.y *v1 + (objN.force.y+objS.force.y) *v2 +  (objNW.force.y+objSW.force.y+objNE.force.y+objSE.force.y)* v3 ) * 1;
		}
	}


	// bounce on border
//	for (var j = 1; j <liquidH - 1; j++) {
//		var i = 1;
//		var i2 = 2;
//			var obj0 = liquid[i +j * liquidW];
//			var obj1 = liquid[i2 +j * liquidW];
//
//			//if(obj0.force.x <0){
//				obj1.delayForce[0].x = obj0.force.x*-1;
//				obj1.delayForce[0].y = obj0.force.y*1;
//
//				obj1.delayForce[0].clampLength(-10,10);
//
//			//}
//
//			//obj0.force2.x += (obj0.delayForce[0].x );
//	}

	// merge force2 to force
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = liquid[i +j * liquidW];
			if (obj.force2.length() > 0.005) {
				obj.force.copy(obj.force2);
				obj.force3.copy(obj.force);
			} else {
				obj.force.copy(obj.force3);
			}
		}
	}
}

function updatePart() {
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if (obj.isActive) {


			var lX = ofClamp(Math.floor(obj.pos.x / unitW), 1, 38);
			var lY = ofClamp(Math.floor(obj.pos.y/unitW),1,38);
			var ind0 = lX + lY * liquidW;


			if (ind0 >= 0 && ind0 < liquidW * liquidH) {


				var vX = obj.pos.x*(-obj.e2)   +   (obj.pos.x+liquid[ind0].force.x*4) *obj.e2;

				var vY = obj.pos.y*(-obj.e2)   +   (obj.pos.y+liquid[ind0].force.y*4) *obj.e2;

				var vXY = new THREE.Vector2(vX, vY);
				vXY.clampLength(0.05, obj.speedMax);

				obj.pos.add(vXY);

				//obj.pos.x = obj.pos.x*obj.e1   +   (obj.pos.x+liquid[ind0].force.x*4) *obj.e2;
				//obj.pos.y = obj.pos.y*obj.e1   +   (obj.pos.y+liquid[ind0].force.y*4) *obj.e2;


				//history

				var pos = new THREE.Vector2();
				pos.copy(obj.pos);
				obj.posHis.unshift(pos);
				while (obj.posHis.length > obj.posHisMax) {
					obj.posHis.pop();
				}



				//handle life
				obj.life--;
				if (obj.life < 0) {
					obj.isActive = false;
				}

				//outbound
				if (obj.pos.x < unitW || obj.pos.x > unitW*liquidW-unitW || obj.pos.y < unitW || obj.pos.y > unitW*liquidH-unitW) {

						obj.isActive = false;
						obj.life = 0;

				}
			}
		}
		//
	}
}

//*********************************************************************

// Render

//*********************************************************************
function render(time) {
	// now = moment();
	now = getTime(new Date());
	t = now - startT;
	//
  if (intro) {
    updateLiquid();
    updatePart();
  }

	TWEEN.update(time);

	cover.update();
	//
	coverCtx.clearRect(0, 0, coverCanvas.width, coverCanvas.height);

  if (intro) {
    drawPart();
  }
  drawCover();
	//
	//
	if(currentWScene!=-1){
		renderWScene(currentWScene);
		renderer.render( scene, camera );
    // console.log(1);
    //parallex
    // if(hasMotion){
    //   if( !isNaN(planeGroup.rotation.y) ){
    //     planeGroup.rotation.y = planeGroup.rotation.y*0.9 -  0.03*forceX*0.1;
    //   }else{
    //     planeGroup.rotation.y = 0;
    //   }
    //   //planeGroup.rotation.y = 0.03*forceX;
    // }else{
    //   planeGroup.rotation.y = -(mousePos.x-  window.innerWidth*0.5)/( window.innerWidth*0.5)* 0.03;
    // }

	}
	requestAnimationFrame(render);
}

function drawPart() {

	var ctx = partCtx;

	ctx.clearRect(0, 0, partCanvas.width, partCanvas.height);
	ctx.fillStyle = "#000";

	//var liquidW = Math.ceil(1200/unitW);//1200
	// var liquidH = Math.ceil(670/unitW);//670

	var _s0 = window.innerWidth/1200;
	var _s1 = window.innerHeight/670;
	var _s = Math.max(_s0, _s1);
	var newW = 1200*_s;
	var newH = 670*_s;
	var _x = (window.innerWidth-newW)*0.5;
	var _y = (window.innerHeight-newH)*0.5;

	var logoStartCol = Math.floor(liquidW*0.5)-4;
	var logoEndCol = Math.floor(liquidW*0.5)+4;
	var logoStartRow = Math.floor(liquidH*0.5)-1;
	var logoEndRow = Math.floor(liquidH*0.5)+1;


	ctx.save();
	ctx.translate(window.innerWidth*0.5,window.innerHeight*0.5);
  ctx.scale(wave.scaleFactor, wave.scaleFactor);
	//if(wave.scaleFactor==1){
		ctx.translate(-window.innerWidth*0.5,-window.innerHeight*0.5);
	//}else {
	//	ctx.translate(-window.innerWidth*0.5+77,-window.innerHeight*0.5+45);
	//}


	ctx.translate(_x,_y);
	ctx.scale(_s,_s);

//
//
//
//
//
//
//
//
//
//

	//ctx.fillRect(0, 0, partCanvas.width, partCanvas.height);
	var pace = 0.5 * Math.sin(t * 0.001 * 0.1);
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {

			var obj = liquid[i +j * liquidW];
			var force = obj.force;
			var ang = force.angle();
			var mag = force.length();
			var _a;

			// the 3 I
			var di1,di2,di3;
			var _dx, _dy;

			_dx = (i-(logoStartCol +1));
			_dy = (j-logoStartRow);
			di1 = Math.sqrt(_dx*_dx + _dy*_dy);
			//if(j>logoStartRow)di1 = 10;

			_dx = (i-(logoStartCol +6));
			_dy = (j-logoStartRow);
			di2 = Math.sqrt(_dx*_dx + _dy*_dy);
			//if(j>logoStartRow)di1 = 10;

			_dx = (i-(logoStartCol +5));
			_dy = (j-(logoStartRow+1));
			di3 = Math.sqrt(_dx*_dx + _dy*_dy);
			//if(j<=logoStartRow)di1 = 10;


			//if(_mode == 10){
			var dMin = Math.min(di1, di2, di3);
			//console.log(di1+"/"+di2+"/"+di3);
			//}
			if(i>= logoStartCol && i< logoEndCol && j>= logoStartRow && j< logoEndRow ){
				// logo position


				_a = wave.wave2Alpha;

			}else{
				//others
				//if mode is 10, a
				if(_mode == 10){
					// use custom calculation to decrease obj.alpha
					_a = obj.alpha - (Math.pow(2,ofMap(dMin,-2,15,0,0.4,true))-1)*0.25;
					_a = Math.max(_a,0);
				}else{
					_a = wave.waveAlpha;
				}
			}

				obj.alpha = _a;
				//draw line

				ctx.save();

				//var _a = obj.alpha;

				ctx.globalAlpha = _a;
				ctx.fillStyle = "#FFF";

				ctx.translate((i+0.5) * unitW   , (j+0.5) * unitW);

				var _rot=0;


				//
				//
				// wave and wake here
				//
				//
				//

				//var tt = t*0.0008-i*0.05-j*0.02*Math.sin(j*0.05+t*0.001+3);
				var tt = t*0.0008-i*0.05-j*0.05;
				var _v = new THREE.Vector2(i-7,j-7);
				var d = _v.length();
				tt = t*0.0013 - d*0.1+100-1;

				// wave speed
				//tt *= 2;
				tt *= 0.5;

				var wake =  Math.sin(tt)+ 1/3*Math.sin(tt*3+0.2) + 1/5*Math.sin(tt*5) ;
				var tt2 = 0.4+t*0.0009+i*0.05-j*0.02;
				var wake2 = Math.sin(tt2)+ 1/3*Math.sin(tt2*3) + 1/5*Math.sin(tt2*5) + 1/7*Math.sin(tt2*7) + 1/9*Math.sin(tt2*9);

				speedFactor = 0;
				//var _rot = ang-Math.PI*0.5 + mag*0.001  + (0.3*Math.PI*Math.sin(i*0.19+t*0.0005+4)+0.3*Math.PI*Math.cos(j*0.19+t*0.0006+2)+t*0.001)*speedFactor ;

				// double wave
				//_rot = wake*2 + wake2*0.8;

				// single save
				_rot = wake*2;

				// add turbulence here
				if(_mode == 50){
					_rot += 0.3*Math.PI*Math.sin(i*0.12+4)+0.3*Math.PI*Math.cos(j*0.12+2)+t*0.001;
				}
				_rot = obj.rot+(_rot+100*Math.PI)%(2*Math.PI);

				//obj.rot = _rot;

				if(_mode == 10){
						ctx.rotate(_rot*(1-wave.slantT)  + 3.6*(wave.slantT));
				}else{
						ctx.rotate(_rot);
				}


				ctx.translate(0,-20*0.5);


				ctx.fillRect(0, 0, ofMap( Math.sin(_rot*2+1)  ,-1,1,1,4,true) , 20);


					//ctx.fillRect(0, 0, 4, 20);
				ctx.globalAlpha = 1;


				ctx.restore();

				// slowly unveil
				//obj.alpha += Math.abs(0.01*Math.sin(i*0.5+t*0.0005) +  0.01*Math.cos(j*0.5+t*0.0006) );

		}
	}


  var _a = wave.partAlpha;
  ctx.globalAlpha = _a;
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if (obj.isActive) {
			//ctx.strokeStyle = "#F05";
			ctx.strokeStyle = obj.strokeStyle;
			ctx.lineWidth = 1;

			ctx.beginPath();
			var pos = new THREE.Vector2(0,0);

			// make line visible
			// if(obj.posHis.length >0){
			// 	var liqID = Math.floor(obj.posHis[0].x/unitW) + Math.floor(obj.posHis[0].y/unitW) * liquidW;
			// 	if(liqID < liquid.length){
			// 		var liq = liquid[liqID];
			// 		//console.log(Math.floor(pos.x/unitW) + Math.floor(pos.y/unitW) * liquidW );
			// 		liq.brightness = 255;
			// 		//
			// 	}
			// }

			for (var j = 0; j < obj.posHis.length; j++) {
				if (j == 0) {
					//ctx.moveTo(obj.posHis[j].x, obj.posHis[j].y);
					pos.copy(obj.posHis[j]);
					ctx.moveTo(pos.x,pos.y);
				} else {
					pos.x = pos.x*0.9 + obj.posHis[j].x*0.1;
					pos.y = pos.y*0.9 + obj.posHis[j].y*0.1;

					//pos.x = obj.posHis[j].x;
					//pos.y = obj.posHis[j].y;


					ctx.lineTo(pos.x,pos.y);
					//ctx.lineTo(obj.posHis[j].x, obj.posHis[j].y);
				}
			}



			ctx.stroke();
		}

		// if(partTotal>500 && _mode == 1){
		// 	changeMode(2);
		// }

	}

	ctx.globalAlpha = 1;


	//draw intruction
  ctx.globalAlpha = wave.swipeToAlpha;
	var img=document.getElementById("swipeToForCanvas");
	if(img.width >0){

		//ctx.drawImage(img,0,0);
		ctx.drawImage(img,1200*0.5-img.width*0.5,670*0.5-img.height*0.5);


	}

	ctx.globalAlpha = 1;
	//draw instruction

	//draw logo
	for(var i=0;i<logoCharList.length;i++){
		var char = logoCharList[i];

		if(char.width > 0){
			var _a = wave.vdChar[i].alpha;
			var _s = wave.vdChar[i].scale;
      var offsetX = wave.vdChar[i].offsetX;
      var offsetY = wave.vdChar[i].offsetY;
      var maskType = wave.vdChar[i].maskType;
      var angEnd = wave.vdChar[i].angEnd;
      var angStart = wave.vdChar[i].angStart;

      var angOffset = -Math.PI*0.5;

      var _x = (logoStartCol)*unitW+((i%8)+0.5)*unitW;
      var _y = (logoStartRow)*unitW+(Math.floor(i/8)+0.5)*unitW;
      var r = 25;

			ctx.globalAlpha = _a;
			ctx.save();
      if(maskType==0){
        ctx.rect(_x-22,_y-22,44,44);
      }else{
        //1
        ctx.beginPath();
        ctx.moveTo(_x,_y);
        //ctx.lineTo();
        ctx.arc(_x, _y, r, angStart+angOffset, angEnd+angOffset, false);
        ctx.lineTo(_x,_y);
      }
      //clipping

      ctx.clip();
      //clipping
      ctx.translate(_x+offsetX,_y+offsetY);
			ctx.scale(_s,_s);
			ctx.drawImage(char,-22,-22,44,44);
			ctx.globalAlpha = 1;
			ctx.restore();
		}
	}
	//
	// var img=document.getElementById("vdLogoForCanvas");
	// if(img.width >0){
	// 	ctx.globalAlpha = wave.vdLogoAlpha;
	// 	ctx.drawImage(img,(logoStartCol)*unitW,(logoStartRow)*unitW);
	// 	ctx.globalAlpha = 1;
	// }
	//draw logo


	ctx.restore();
}




function drawPartImageData() {

	var ctx = partCtx;

	var canvasData = ctx.getImageData(0, 0, canvasIntro.width, canvasIntro.height);
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if (obj.isActive) {


			var pos = new THREE.Vector2(0,0);
			for (var j = 0; j < obj.posHis.length; j++) {
				if (j == 0) {
					//ctx.moveTo(obj.posHis[j].x, obj.posHis[j].y);
					pos.copy(obj.posHis[j]);
					//ctx.moveTo(pos.x,pos.y);

					drawPixel(canvasData,Math.floor(pos.x), Math.floor(pos.y), obj.cR, obj.cG, obj.cB, 255);
					//drawPixel(canvasData,Math.floor(pos.x)+1, Math.floor(pos.y), obj.cR, obj.cG, obj.cB, 255);
					//drawPixel(canvasData,Math.floor(pos.x)+1, Math.floor(pos.y)+1, obj.cR, obj.cG, obj.cB, 255);
					//drawPixel(canvasData,Math.floor(pos.x), Math.floor(pos.y)+1, obj.cR, obj.cG, obj.cB, 255);




				}
			}

		}
	}
	ctx.putImageData(canvasData, 0, 0);
}

function mouseMove(x, y) {

	//mapping fullscreen to 1200 x 670
	x = ofMap(x,0,window.innerWidth,0,1200,true);
	y = ofMap(y,0,window.innerHeight,0,670,true);

	var mouseX = x;
	var mouseY = y;
	mousePosP.copy( mousePos);
	mousePos.set(mouseX, mouseY);

	//
	//check mouse over
	var dM = new THREE.Vector2();
	dM.subVectors(mousePos, mousePosP).multiplyScalar(2);
	var lX = Math.floor(mouseX / unitW);
	var lY = Math.floor(mouseY / unitW);
	var ind = lX + lY * liquidW;

		//liquid[ind].fX += dM.x*10;
		//liquid[ind].fY += dM.y*10;

		for (var i = 0; i < liquidW; i++) {
			for (var j = 0; j < liquidH; j++) {

				var ind2 = i + j * liquidW;
				var dist = Math.abs(lY-j)+Math.abs(lX-i);
				var atten = ofMap(dist,0,liquidH*0.2,1,0,true)*0.3;
				if (ind2 < liquidW * liquidH) {
					liquid[ind2].force.add(dM.clone().multiplyScalar(atten) );
				}
			}
		}


		//liquid[ind].force.add(dM);

	//spawn part
	for(var i=0;i<5;i++){

		var ang = (Math.atan2(mouseY-670/2, mouseX-1200/2 )/Math.PI*180+360)%360;
		var hue;
		if(ang>180){
			hue = Math.floor(ofMap(ang,180,360,15,40,true));
		}else{
			hue = Math.floor(ofMap(ang,0,180,200,230,true));
		}
		//var brightness = Math.floor(ofRandom(40,70));
		hue = 50;
		var brightness = 100;

		var col = new THREE.Color("hsl( "+hue+", 100%, "+brightness+"%)");
		//var col = new THREE.Color("hsl( 50, 0%, 50%)");

		spawnPart(mouseX+ofRandom(-5,5),mouseY+ofRandom(-5,5),col.r*255,col.g*255,col.b*255,partLife+ofRandom(0,50));
		partTotal ++;
	}

}

function spawnPart(x,y,r,g,b,life) {
	var id = getFreePart();
	//var color = new THREE.Color("hsl(0, 0%, "+Math.floor(ofRandom(50,100))+"%)");
	if(id!=-1){
		var obj = partSys[id];
		obj.isActive = true;
		obj.pos.set(x,y);
		obj.life = life;
		obj.posHis = new Array();
		//var color = new THREE.Color("hsl("+Math.floor(t%255 )+", 100%, "+Math.floor(ofRandom(0,100))+"%)");
		var color = new THREE.Color("rgb("+Math.floor(r)+", "+Math.floor(g)+", "+Math.floor(b)+")");
		obj.color = color;
		obj.cR = r;
		obj.cG = g;
		obj.cB = b;
		obj.strokeStyle = "#"+color.getHexString();

	}
}

function getPartID(x,y) {

}

function getFreePart() {
	var id = -1;
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if(!obj.isActive){
			id = i;
			break;
		}
	}
	return id;
}

function drawPixel (canvasData,x, y, r, g, b, a) {
    var index = (x + y * canvas.width) * 4;
    canvasData.data[index + 0] = r;
    canvasData.data[index + 1] = g;
    canvasData.data[index + 2] = b;
    canvasData.data[index + 3] = a;
}

function enterCover() {
  cover.tween = new TWEEN.Tween(cover).to({scale2:1.2},500).easing(TWEEN.Easing.Quintic.InOut).start();
}

function leaveCover() {
  cover.tween = new TWEEN.Tween(cover).to({scale2:1},500).easing(TWEEN.Easing.Quintic.InOut).start();
}

function minifyCover(isAnimated){
	cover.isOn = false;
	var scale = 0.0001;
	if(isAnimated){
			cover.tween = new TWEEN.Tween(cover).to({scale:scale},2000).easing(TWEEN.Easing.Quintic.Out).start();
	}else{
			cover.scale = scale;
	}

}

function closeCover(isAnimated){
	cover.isOn = true;
	var scale = getCoverCloseScale();
	if(isAnimated){
			cover.tween = new TWEEN.Tween(cover).to({scale:scale},2000).easing(TWEEN.Easing.Quintic.Out).start();

      if (!detectIE()) {
        setCutOffFreq(2000);
      }
	}else{
			cover.scale = scale;
	}

}

function expandCover(isAnimated) {
	cover.isOn = false;
	var scale = getCoverExpandScale();
	if(isAnimated){
		cover.tween = new TWEEN.Tween(cover).to({scale:scale},2000).easing(TWEEN.Easing.Quintic.InOut).start();

    if (!detectIE()) {
      setCutOffFreq(20000);
    }
	} else{
			cover.scale = scale;
	}
}

function getCoverCloseScale() {

	return Math.min(window.innerWidth,window.innerHeight)/ 340 *0.75;

}
function getCoverExpandScale() {
	var wh = window.innerHeight;
	var ww = window.innerWidth
	return   Math.sqrt(wh*wh+ww*ww)  /84;
}

//function checkScroll() {}

function checkResize() {
  if (coverCanvas) {
    coverCanvas.width = window.innerWidth;
    coverCanvas.height = window.innerHeight;

    if(cover.tween){
      cover.tween.stop();
    }
    if(cover.isOn){
      closeCover(false);
    }else{
      expandCover(false);
    }

    //THREE
    if(camera){
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
    }
    if(renderer){
      renderer.setSize( window.innerWidth, window.innerHeight );
    }

    //part
    if(_mode==50){
      partCanvas.width = 1024;
      partCanvas.height = 1024;
    }else{
      partCanvas.width = window.innerWidth;
      partCanvas.height = window.innerHeight;
    }

    //if()
    //$(".section").height(wh);
  }
}

function easeInOutCubic(x, t, b, c, d) {
	if ((t/=d/2) < 1) return c/2*t*t*t + b;
	return c/2*((t-=2)*t*t + 2) + b;
}

function enterSite(){
	changeMode(40);
}

// Do not delete

if (!detectIE()) {
  var filter = new Tone.Filter(2000,"lowpass").toMaster();

  var player = new Tone.Player({
    "url" : "https://www.victoriadockside.com/static/VIctoria_Dockside_oct26.mp3",
    "loop" : true
  }).connect(filter);

  player.autostart = false;
}

function setCutOffFreq(freq) {
  filter.frequency.input.value = freq;
}
function stopMusic() {
	const audioElement = document.getElementById('bg-music');

  if (!detectIE()) {
		player.stop();
		audioElement.setAttribute('data-status', 'paused');
  } else {
    audioElement.pause();
		audioElement.setAttribute('data-status', 'paused');
  }
}
function startMusic() {
	const audioElement = document.getElementById('bg-music');
	let status;

  if (!detectIE()) {
		audioElement.muted = true;
		audioElement.play();

		if (audioElement.paused) {
			status = 'paused';
		} else {
			status = 'playing';
		}

		audioElement.setAttribute('data-status', status);
		audioElement.pause();
		audioElement.muted = false;

		player.start();
  } else {
		audioElement.play();
		
		if (audioElement.paused) {
			status = 'paused';
		} else {
			status = 'playing';
		}

		audioElement.setAttribute('data-status', status);
  }
}

export {
  expandCover,
  closeCover,
  cover,
  enterSite,
  setCutOffFreq,
  stopMusic,
  startMusic,
  enterCover,
  leaveCover
};



// WEBPACK FOOTER //
// ./src/pp.js